import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import { createContactPerson, deleteContactPersonByIdAsync, getContactPersonsByDebtorIdAsync, updateContactPersonAsync } from '@application/features/debtors/debtorThunk';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { handleRolePermission } from '@infrastructure/helpers';
import VnButton from '@ui/components/VnButton';
import VnConfirmationModel from '@ui/components/VnConfirmationModel';
import VnValidation from '@ui/components/VnValidation';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
const AddContactForm = ({ onClose, isContactPersonTabBold }) => {
    const { contactPerson } = useAppSelector((state) => state.debtors);
    const [isDebtorDeletePopup, setisContactDeletePopup] = useState(false);
    const dispatch = useAppDispatch();
    const { id } = useParams();
    const onCancelDeleteClicked = () => {
        setisContactDeletePopup(false);
    };
    const deleteContactPerson = () => {
        setisContactDeletePopup(true);
    };
    const onDeleteClicked = () => {
        dispatch(deleteContactPersonByIdAsync(contactPerson.id))
            .unwrap()
            .then(() => {
            onClose();
            setisContactDeletePopup(false);
            dispatch(getContactPersonsByDebtorIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                if (isContactPersonTabBold && res.length > 0) {
                    isContactPersonTabBold(true);
                }
                else {
                    isContactPersonTabBold && isContactPersonTabBold(false);
                }
            });
        });
    };
    const { setValue, handleSubmit, register, formState: { errors } } = useForm({
        defaultValues: {}
    });
    const onsubmit = (data) => {
        data.debtorId = parseInt(id);
        dispatch(createContactPerson(data))
            .unwrap()
            .then(() => {
            onClose();
            if (id) {
                dispatch(getContactPersonsByDebtorIdAsync(parseInt(id)))
                    .unwrap()
                    .then((res) => {
                    if (isContactPersonTabBold && res.length > 0) {
                        isContactPersonTabBold(true);
                    }
                    else {
                        isContactPersonTabBold && isContactPersonTabBold(false);
                    }
                });
            }
        });
    };
    const onUpdateSubmit = (data) => {
        data.debtorId = parseInt(id);
        data.id = contactPerson.id;
        dispatch(updateContactPersonAsync(data))
            .unwrap()
            .then(() => {
            onClose();
            if (id) {
                dispatch(getContactPersonsByDebtorIdAsync(parseInt(id)));
            }
        });
    };
    useEffect(() => {
        setValue('firstName', contactPerson?.firstName);
        setValue('lastName', contactPerson?.lastName);
        setValue('position', contactPerson?.position);
        setValue('phoneNumber', contactPerson?.phoneNumber);
        setValue('email', contactPerson?.email);
        setValue('note', contactPerson?.note);
    }, [contactPerson]);
    return (_jsx(_Fragment, { children: _jsxs("div", { className: 'mt-4', children: [_jsxs("form", { onSubmit: contactPerson?.id ? handleSubmit(onUpdateSubmit) : handleSubmit(onsubmit), children: [_jsxs("div", { className: 'row', children: [_jsxs("div", { className: 'col-sm-6', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Voornaam*" }), _jsx("input", { type: 'text', className: 'form-control vn-Input', placeholder: 'Voer voornaam in', ...register('firstName', {
                                                required: 'Dit veld is verplicht'
                                            }) }), _jsx(VnValidation, { fieldError: errors.firstName })] }), _jsxs("div", { className: 'col-sm-6', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Achternaam" }), _jsx("input", { type: 'text', className: 'form-control vn-Input', placeholder: 'Voer achternaam in', ...register('lastName') }), _jsx(VnValidation, { fieldError: errors.lastName })] })] }), _jsx("div", { className: 'row mt-4', children: _jsxs("div", { className: 'col-sm-6', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Functie" }), _jsx("input", { type: 'text', className: 'form-control vn-Input', placeholder: 'Voer functie in', ...register('position') }), _jsx(VnValidation, { fieldError: errors.position })] }) }), _jsxs("div", { className: 'row mt-4', children: [_jsxs("div", { className: 'col-sm-6', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Telefoonnummer" }), _jsx("input", { type: 'text', className: 'form-control vn-Input', placeholder: 'Voer telefoonnummer in', ...register('phoneNumber'), onInput: (e) => {
                                                e.currentTarget.value = e.currentTarget.value.replace(/[^\d+\s()-]/g, '');
                                            } }), _jsx(VnValidation, { fieldError: errors.phoneNumber })] }), _jsxs("div", { className: 'col-sm-6', children: [_jsx("label", { className: 'form-label vn-text-label', children: "E-mailadres" }), _jsx("input", { type: 'text', className: 'form-control vn-Input', placeholder: 'Voer email in', ...register('email', {
                                                pattern: {
                                                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                                    message: 'Ongeldig e-mailadres'
                                                }
                                            }) }), _jsx(VnValidation, { fieldError: errors.email })] })] }), _jsx("div", { className: 'row mt-4', children: _jsxs("div", { className: 'col-sm-12', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Opmerkingen" }), _jsx("textarea", { className: 'vn-Input', rows: 8, placeholder: 'Voer operkingen in', ...register('note', {}) }), _jsx(VnValidation, { fieldError: errors.note })] }) }), _jsx("div", { className: 'vn-Form_Footer mt-4', children: _jsxs("div", { style: { display: 'flex', marginLeft: 'auto' }, children: [_jsx(VnButton, { customClassName: 'Vn-cancel-button', mode: 'secondary', onClick: onClose, type: 'button', children: "Annuleren" }), contactPerson?.id ? (_jsxs(_Fragment, { children: [_jsx(VnButton, { style: { marginLeft: '8px' }, customClassName: 'vn-popup-delete-button', mode: 'danger', type: 'button', onClick: () => deleteContactPerson(), isDisabled: !handleRolePermission(Permission.KLANTEN, PermissionType.Delete), children: "Verwijderen" }), _jsx(VnButton, { customClassName: 'Vn-save-button vn-popup-save-button', mode: 'primary', type: 'submit', isDisabled: !handleRolePermission(Permission.KLANTEN, PermissionType.Update), children: "Opslaan" })] })) : (_jsx(VnButton, { customClassName: 'Vn-save-button vn-popup-save-button', mode: 'primary', type: 'submit', isDisabled: !handleRolePermission(Permission.KLANTEN, PermissionType.Create), children: "Opslaan" }))] }) })] }), _jsx(VnConfirmationModel, { title: 'Wilt u dit record verwijderen?', onCancel: () => onCancelDeleteClicked(), onConfirm: () => onDeleteClicked(), onOpen: isDebtorDeletePopup })] }) }));
};
export default AddContactForm;
